import GuestForm from '../../forms/GuestForm';
import Container from '../../components/Container';
import Header from '../../components/Header';

const GuestCreatePage = () => {
    return (
        <Container containerName={'landing'}>
            <Header title={'Add Guest'} subtitle={''} bottomBorder={true} />
            <GuestForm action={'add'} />
        </Container>
    );
};

export default GuestCreatePage;
